import * as z from "zod";

export const GroupSizeSchema = z.number().min(1).default(1);
export type GroupSize = z.infer<typeof GroupSizeSchema>;
